import { Users } from "lucide-react";
import { Tooltip } from "react-tooltip";

const InterviewAnalytics = ({ dashboardData }) => {
  const interviewStatsLeft = [
    {
      label: "Completed",
      value: dashboardData?.interview?.completed || 0,
      color: "#133F7D",
    },
    {
      label: "Disqualified",
      value: dashboardData?.interview?.disqualified || 0,
      color: "#D3040A",
    },
    {
      label: "Scheduled",
      value: dashboardData?.interview?.scheduled || 0,
      color: "#133F7D",
    },
    {
      label: "Pending",
      value: dashboardData?.interview?.pending || 0,
      color: "#626262",
    },
    {
      label: "Resume Rejected",
      value: dashboardData?.interview?.resumeRejected || 0,
      color: "#D3040A",
    },
  ];

  const interviewStatsRight = [
    {
      label: "Qualified",
      value: dashboardData?.interview?.qualified || 0,
      color: "#187708",
    },
    {
      label: "In Progress",
      value: dashboardData?.interview?.inProgress || 0,
      color: "#006B6F",
    },
    {
      label: "Follow-up",
      value: dashboardData?.interview?.followUp || 0,
      color: "#D68000",
    },
    {
      label: "No Response",
      value: dashboardData?.interview?.noResponse || 0,
      color: "#626262",
    },
    {
      label: "Cancelled",
      value: dashboardData?.interview?.canceled || 0,
      color: "#EF4444",
    },
  ];
  return (
    <div className="chart-container interview-analytics-container">
      <h3 className="chart-title">
        <Users style={{ color: "#0891B2" }} />
        Interview Analytics
      </h3>
      <div className="text-center">
        <div className="stat-value mt-20 interview-analytics-total">
          {dashboardData?.interview?.total || 0}
        </div>
        <div className="stat-subtitle-2 fs-6 mt-20">Total Interviews</div>
      </div>
      <div className="interview-analytics-legends p-3">
        <ul className="legend-list">
          {interviewStatsLeft.map((item, index) => (
            <li key={index} className="legend-item">
              <div className="legend-label">
                <div
                  className="legend-color"
                  style={{ backgroundColor: item.color }}
                ></div>
                <span
                  data-tooltip-id="interview-legend-tooltip"
                  data-tooltip-content={item.label}
                >
                  {item.label}
                </span>
              </div>
              <span className="legend-value">{item.value}</span>
            </li>
          ))}
        </ul>
        <ul className="legend-list">
          {interviewStatsRight.map((item, index) => (
            <li key={index} className="legend-item">
              <div className="legend-label">
                <div
                  className="legend-color"
                  style={{ backgroundColor: item.color }}
                ></div>
                <span
                  data-tooltip-id="interview-legend-tooltip"
                  data-tooltip-content={item.label}
                >
                  {item.label}
                </span>
              </div>
              <span className="legend-value">{item.value}</span>
            </li>
          ))}
        </ul>
        <Tooltip
          id="interview-legend-tooltip"
          place="top"
          style={{ padding: "4px 8px", fontSize: "12px", maxWidth: "260px" }}
        />
      </div>
    </div>
  );
};
export default InterviewAnalytics;
